import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-site-preparation-guidelines',
    templateUrl: './site-preparation-guidelines.component.html',
    styleUrls: ['./site-preparation-guidelines.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class SitePreparationGuidelinesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
